import { type ReactElement } from 'react';
import { NeonButtonFooter, NeonModalDialog } from '@ps-refarch-ux/neon';
import { NeonButtonTypes } from '@/constants/neon-constants';
import { DELETE_COURSE_MODAL_TEXT } from '@/constants/course-catalog-constants';
import modalStyles from './course-catalog-modals.module.scss';

export interface DeleteCourseModalProps {
  isOpen: boolean;
  courseName: string;
  onConfirm: () => void;
  onClose: () => void;
  isDeleting: boolean;
}

export function DeleteCourseModal({
  isOpen,
  courseName,
  onConfirm,
  onClose,
  isDeleting,
}: DeleteCourseModalProps): ReactElement | null {
  if (!isOpen) {
    return null;
  }

  return (
    <NeonModalDialog id="delete-course-modal" neonDialogHasClosed={onClose} dataSize="small">
      <div data-slot="dialog-header-title">
        {DELETE_COURSE_MODAL_TEXT.TitlePrefix} {courseName}?
      </div>
      <div data-slot="dialog-body">
        <p className={`__neon__text ${modalStyles.modalBodyText}`}>
          {DELETE_COURSE_MODAL_TEXT.Body1}
        </p>
        <p className={`__neon__text ${modalStyles.modalBodyText}`}>
          {DELETE_COURSE_MODAL_TEXT.Body2}
        </p>
      </div>
      <div data-slot="dialog-button-footer">
        <NeonButtonFooter
          id="delete-course-footer"
          buttons={[
            {
              id: 'delete-course-cancel',
              text: DELETE_COURSE_MODAL_TEXT.Cancel,
              type: NeonButtonTypes.Borderless,
              onClick: (e): void => {
                (e.target as HTMLElement)?.dispatchEvent(
                  new Event('neonDialogClose', { bubbles: true })
                );
              },
            },
          ]}
          primaryButton={{
            id: 'delete-course-confirm',
            text: DELETE_COURSE_MODAL_TEXT.Confirm,
            type: NeonButtonTypes.Tertiary,
            disabled: isDeleting,
            onClick: onConfirm,
          }}
        />
      </div>
    </NeonModalDialog>
  );
}
